import { atom } from "recoil";


export const openSelectMovingModalState = atom<boolean>({
    key: "openSelectMovingModalState",
    default: true as boolean,
});
